import { computedFrom } from "aurelia-binding";
import { EventAggregator } from "aurelia-event-aggregator";
import { MepInsightsContributorsToEmissions, MepInsightsRequest } from "../../../../../../../../models/mep/mep-insights.models";
import { MepEventMessages, MepTabsEnum } from "../../../../../../../../models/mep/mep.models";
import { MepInsightsService } from "../../../../../../../../services/mep/mep-insights.service";
import { useView } from "aurelia-framework";

@useView('views/pages/modules/mep/tabs/mep-insights/partials/mep-insights-top-contributors-to-emissions/mep-insights-top-contributors-to-emissions.html')
export class MepInsightsContributorsToEmissionsViewModel{
    contributorsToEmissions: MepInsightsContributorsToEmissions[];
    isContributorsLoading: boolean;
    isTopContributors: boolean;
    isMepTrial: boolean = false;
    
    constructor(private mepInsightsService: MepInsightsService, private eventAggregator: EventAggregator, isTopContributors: boolean, isMepTrial: boolean) {
        this.isTopContributors = isTopContributors;
        this.isMepTrial = isMepTrial;
    }

    @computedFrom("isTopContributors")
    get contributersType(): string
    {
        return this.isTopContributors? 'Highest': 'Lowest';
    }

    getContributorsToEmissions(request: MepInsightsRequest): Promise<string> {
        return new Promise<string>((resolve, reject) => {
            this.isContributorsLoading = true;
            if (this.isTopContributors) {
                this.mepInsightsService.getMepInsightsTopContributorsToEmissions(request).then(response => {
                    this.contributorsToEmissions = response.topContributors;
                    this.isContributorsLoading = false;
                    resolve(null);
                }).catch(() => {
                    this.isContributorsLoading = false;
                    reject("MEP Insights Top Contributors to Emissions - Error retrieving the top contributors to emissions!");
                });
            }
            else {
                this.mepInsightsService.getMepInsightsSmallestContributorsToEmissions(request).then(response => {
                    this.contributorsToEmissions = response.smallestContributors;
                    this.isContributorsLoading = false;
                    resolve(null);
                }).catch(() => {
                    this.isContributorsLoading = false;
                    reject("MEP Insights Top Contributors to Emissions - Error retrieving the top contributors to emissions!");
                });
            }
        });
    }

    clearContributorsData() {
        this.contributorsToEmissions = null;
    }


    getPortActivityUnit(contributor: MepInsightsContributorsToEmissions) {
        const tugboat = "Tugboat";
        if (contributor.vesselType == tugboat) {
            return contributor.portActivity == 1 ? "Tug Job" : "Tug Jobs";
        }
        else {
            return contributor.portActivity == 1 ? "port call" : "port calls";
        }
    }

    navigateToVesselsTab(contributor: MepInsightsContributorsToEmissions) {
        this.eventAggregator.publish(MepEventMessages.ChangeMepTab, {
            step: MepTabsEnum.Vessels,
            imo: contributor.imo
        });
    }
}
